/* eslint-disable no-template-curly-in-string */
import * as Yup from 'yup';

/**
 * @description Setup Yup
 */
Yup.setLocale({
  mixed: {
    required: '此欄位不得為空值'
  },
  string: {
    max: '長度不得超過 ${max} 字元',
    min: '長度不得小於 ${min} 字元'
  },
  number: {
    max: '不得超過 ${max} 數字',
    min: '不得小於 ${min} 數字'
  }
});
